import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mains" }
const _hoisted_2 = { class: "register bg-bg" }
const _hoisted_3 = { class: "cont" }
const _hoisted_4 = { class: "be-info" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "conted" }
const _hoisted_7 = { class: "conteds" }
const _hoisted_8 = { class: "custom-title" }
const _hoisted_9 = { class: "date" }
const _hoisted_10 = { class: "states" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "SQ" }
const _hoisted_15 = {
  key: 0,
  class: "state"
}
const _hoisted_16 = {
  key: 1,
  class: "state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "预约记录（因公）", -1)),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.list.length == 0)
            ? (_openBlock(), _createBlock(_component_van_empty, {
                key: 0,
                description: "暂无信息",
                "image-size": "80"
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "Records",
              key: i,
              onClick: ($event: any) => (_ctx.godetail(item))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, "拜访：" + _toDisplayString(item.beAccessOrgName), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.visiStartTime.slice(0, 10)), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _cache[0] || (_cache[0] = _createTextVNode(" 状态： ", -1)),
                    (item.approvalState == 5)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "审批中"))
                      : _createCommentVNode("", true),
                    (item.approvalState == 10)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "审批完成"))
                      : _createCommentVNode("", true),
                    (item.approvalState == 15)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "审批拒绝"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(item.visiCampus), 1)
                ])
              ]),
              (item.Isexpired)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, "已过期"))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, "未过期"))
            ], 8, _hoisted_5))
          }), 128))
        ])
      ])
    ])
  ]))
}